import Link from '../../../components/ui/Link';

export default function ServiceCard({
  id,
  name,
  desc,
  image,
  className,
}: {
  id: number;
  name: string;
  className?: string;
  desc?: string;
  image: string;
}) {
  return (
    <article
      className={`${className} shadow-md hover-shadow group rounded-lg overflow-hidden select-none cursor-pointer relative transition-all duration-500 ease-in-out h-32`}
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 ease-in-out group-hover:scale-125"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <Link to={`/service/${id}`}>
        <div className="relative flex flex-col justify-start text-white hover:bg-black/40 transition-color duration-500 p-4 h-full bg-black/30">
          <h3 className="text-lg font-bold line-clamp-1">{name}</h3>
          <p className="font-medium text-xs line-clamp-4">{desc}</p>
        </div>
      </Link>
    </article>
  );
}
